"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _omit = _interopRequireDefault(require("../utils/underscore/omit"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _classnames = _interopRequireDefault(require("classnames"));

var _sizes = require("HubStyleTokens/sizes");

var _theme = require("HubStyleTokens/theme");

var _misc = require("HubStyleTokens/misc");

var _UIList = _interopRequireDefault(require("../list/UIList"));

var _H = _interopRequireDefault(require("../elements/headings/H7"));

var _HR = _interopRequireDefault(require("../elements/HR"));

var RenderProp = _interopRequireWildcard(require("../utils/propTypes/renderProp"));

var _Styles = require("../utils/Styles");

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  left: ", "px;\n  position: relative;\n  width: calc(100% + ", ");\n  ", "\n\n  &:hover {\n    background-color: ", ";\n    ", ";\n  }\n\n  a {\n    ", "\n  }\n\n  && a,\n  button {\n    ", "\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  ", ";\n  color: ", ";\n  line-height: 16px;\n  padding: ", " ", ";\n  padding-right: ", ";\n  text-decoration: none;\n  width: 100%;\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    z-index: ", ";\n  }\n\n  .private-link--external__icon {\n    margin-left: auto;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n  background-color: ", ";\n  min-height: 40px;\n\n  a,\n  button {\n    font-weight: ", " !important;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  word-wrap: break-word;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Nav = _styledComponents.default.nav.withConfig({
  displayName: "UILegacySideNav__Nav",
  componentId: "sc-1hr771x-0"
})(_templateObject());

var activeStyles = (0, _styledComponents.css)(_templateObject2(), (0, _Styles.setBorderRadius)('2px'), _theme.SIDENAV_SELECTED_BACKGROUND_COLOR, _misc.WEB_FONT_DEMI_BOLD_WEIGHT);
var linkStyles = (0, _styledComponents.css)(_templateObject3(), _Styles.FONT_FAMILIES.default, _theme.SIDENAV_FOREGROUND_COLOR, _sizes.NAV_ITEM_PADDING_Y, _sizes.NAV_ITEM_PADDING_LEFT, _sizes.NAV_ITEM_PADDING_RIGHT, _sizes.MERCURY_LAYER);
var SideNavChild = (0, _styledComponents.default)(function (props) {
  var className = props.className,
      children = props.children,
      __hovered = props.hovered,
      __isActive = props.isActive,
      rest = (0, _objectWithoutProperties2.default)(props, ["className", "children", "hovered", "isActive"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: className
  }, rest), children);
}).withConfig({
  displayName: "UILegacySideNav__SideNavChild",
  componentId: "sc-1hr771x-1"
})(_templateObject4(), parseInt(_sizes.NAV_ITEM_PADDING_LEFT, 10) * -1, _sizes.NAV_ITEM_PADDING_LEFT, function (_ref) {
  var isActive = _ref.isActive;
  return isActive && activeStyles;
}, _theme.SIDENAV_HOVERED_BACKGROUND_COLOR, (0, _Styles.setBorderRadius)('2px'), (0, _Styles.setFontSmoothing)('auto'), linkStyles);

var SideNavHeading = function SideNavHeading(props) {
  var headingText = props.headingText;
  return _react.default.createElement(_H.default, null, headingText);
};

SideNavHeading.propTypes = {
  headingText: _propTypes.default.node
};

var _default = _react.default.createClass({
  displayName: "UILegacySideNav",
  propTypes: {
    active: _propTypes.default.string,
    children: _propTypes.default.node,
    divider: _propTypes.default.bool,
    headingText: _propTypes.default.node,
    Heading: RenderProp.getPropType(SideNavHeading)
  },
  getDefaultProps: function getDefaultProps() {
    return {
      active: null,
      Heading: SideNavHeading,
      headingText: '',
      divider: false
    };
  },
  renderHeading: function renderHeading(_ref2) {
    var Heading = _ref2.Heading,
        headingText = _ref2.headingText;
    return headingText ? _react.default.createElement(Heading, {
      headingText: headingText
    }) : null;
  },
  render: function render() {
    var _this$props = this.props,
        active = _this$props.active,
        children = _this$props.children,
        className = _this$props.className,
        divider = _this$props.divider,
        Heading = _this$props.Heading,
        headingText = _this$props.headingText,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["active", "children", "className", "divider", "Heading", "headingText"]);
    var classes = (0, _classnames.default)(className, 'private-side-nav');
    return _react.default.createElement(Nav, (0, _extends2.default)({
      className: classes
    }, rest), divider ? _react.default.createElement(_HR.default, null) : null, this.renderHeading({
      divider: divider,
      Heading: Heading,
      headingText: headingText
    }), _react.default.createElement(_UIList.default, {
      className: "private-nav"
    }, _react.Children.map(children, function (child) {
      var isActive = false;
      var childWithoutNavId;

      if (child && child.props && child.props.navId) {
        isActive = active === child.props.navId;
        childWithoutNavId = _react.default.createElement(child.type, (0, _omit.default)(child.props, 'navId'));
      }

      var childClasses = (0, _classnames.default)('private-side-nav__item', {
        'private-side-nav__item--active': isActive
      });
      return _react.default.createElement(SideNavChild, {
        "aria-current": isActive ? 'true' : null,
        className: childClasses,
        isActive: isActive
      }, childWithoutNavId || child);
    })));
  }
});

exports.default = _default;
module.exports = exports.default;